import React from 'react';
import Text from '../text';

const Tab = ({onClick,active, label, ...props}) => {

    return(
        <Text tag="div" onClick={onClick} color={active?"primary":"secondary"} {...props} variant="sm">
            {label}
        </Text>
    )
}

export default Tab;